import C7List from '@/pages/components/manage/gov/c7/C7List';

export default {
    list: C7List,
    recordRepresentation: 'companyName',
};
